var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288 156c4 0 7 3 7 8 0 4-3 7-7 7h-1c-4 0-7-3-7-7 0-5 3-8 7-8h1zM199 156c4 0 7 3 7 8 0 4-3 7-7 7s-8-3-8-7c0-5 4-8 8-8zM110 156c5 0 8 3 8 8 0 4-3 7-8 7-4 0-7-3-7-7 0-5 3-8 7-8z M1 230V97c0-44 0-66 15-81S53 1 97 1h213c44 0 65 0 81 15v1c8 7 11 17 13 30s2 29 2 50v133c0 44 0 66-15 81-8 8-18 11-32 13-12 2-28 2-49 2h-11c-1 0-2 0-3 1s-1 2-1 3v58c0 4-1 8-3 10-2 3-4 4-6 6h-1c-2 1-5 1-7 1h-1c-3 0-6-1-9-3l-98-71c-2-2-5-3-7-4-3 0-6-1-8-1H97c-44 0-66 0-81-15-8-8-12-18-14-31-1-13-1-29-1-50zM16 97v133c0 21 0 36 1 48 2 10 4 17 9 22 11 11 31 11 71 11h58c4 0 8 1 13 2 3 1 7 3 11 6l98 71c1 1 1 1 3 0v-60c0-5 2-10 6-13 3-4 8-6 13-6h11c20 0 36 0 47-1 11-2 18-5 23-10 11-10 11-30 11-70V97c0-21 0-36-2-48-1-10-4-17-9-22-11-11-31-11-70-11H97c-40 0-60 0-71 11-10 10-10 30-10 70z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.87a664e65884ca50acf89b1086c25dc2.svg";
export { ForwardRef as ReactComponent };